import {InventoryTranslations} from '../typing/translations';

export const defaultTranslation: InventoryTranslations = {
  buildMyDeal: {
    onlineSalesLabel: 'Build my deal',
  },
  modals: {
    modalBuildMyDealToolTip: {
      title: 'What is Build My Deal?',
      description:
        'With Build My Deal, you can explore pricing, payments and lease finance options all online. Once you see a price you like, you can schedule a time online to complete your purchase.',
    },
    modalZip: {
      title: 'Set your location',
      description:
        "To find dealers, inventory, and special offers near you, we'll need your zip code.",
      goCtaLabel: 'Go',
      privacyLinkCta: 'View Privacy Policy',
      inputMessage: {
        label: 'Enter your ZIP code',
        error: 'Invalid ZIP code',
        placeholder: 'Enter your Zip Code',
      },
    },
    modalHandOffNoBuying: {
      title: 'Shop online and find the vehicle you want.',
      dealerStepCard: {
        title: 'Select vehicle from dealer inventory.',
        msrp: 'Total MSRP',
        localDealer: 'Your selected vehicle and local dealership.',
        distance: 'mi away',
      },
      steps: [
        {
          title:
            'View real photos, pricing and details of the Volkswagen near you.',
          descriptionMarkdown:
            '<p>Your next Volkswagen is unique and your local dealer has the best information on what makes it special, including details on payments, incentives and special offers.</p> ',
          number: 2,
          icon: 'car-document',
          id: 'car-document-step',
        },
        {
          title: 'Choose how you want to move forward:click, call or come by.',
          descriptionMarkdown:
            '<p>Your name, address and some basic information will help the dealer start to build a relationship with you.</p> <p>It’s normal to have questions when considering buying a car. From specifics about trim and features, to a conversation about the dealer’s use of technology, feel free to click to submit your information, call for discussion, or come to the physical dealership. </p> ',
          number: 3,
          icon: 'chat',
          id: 'chat-step',
        },
        {
          title: 'Schedule time with the Dealer to check out the vehicle.',
          descriptionMarkdown:
            '<p>Experiencing the vehicle is an important part of the process. The Dealer will also explain available offsite test drive programs and contactless pickup options (if available).</p> ',
          number: 4,
          icon: 'contact-dealer',
          id: 'schedule-step',
        },
      ],
      dealerWebSite: "Go to the dealer's site",
      dealerWebSiteModified: 'Build my deal',
    },
    modalHandOffOnlineBuying: {
      title: "Continue building your deal on the dealer's website",
      subtitle: 'What to expect:',
      dealerStepCard: {
        title: '**$$modelName$$**',
        msrp: 'Total MSRP',
        localDealer: 'Your selected vehicle and local dealership.',
        distance: 'mi away',
      },
      steps: [
        {
          title: '',
          descriptionMarkdown:
            '<p>You can explore pricing, payment and lease finance options all online.</p> ',
          number: 2,
          icon: 'calculator',
          id: 'car-exploring-step',
        },
        {
          title: '',
          descriptionMarkdown:
            '<p>Then schedule a time online with the dealer to confirm and complete your purchase. </p> ',
          number: 3,
          icon: 'contact-dealer',
          id: 'chat-step',
        },
      ],
      dealerWebSite: 'Build my deal >',
      dealerWebSiteModified: 'Build my deal',
    },
    modalDealerRedirect: {
      title: 'You’ll be redirected to the dealer’s site on the other tab.',
      description: 'You can start the buying process on the dealer’s site.',
      closeCtaLabel: 'Go to dealer’s site',
    },
    modalCarFaxRedirect: {
      title: 'You are now leaving this site',
      description: 'You will be redirected to carfax.com',
      closeCtaLabel: 'Continue to CARFAX',
    },
    makeOffer: {
      formName: 'Make an Offer',
      description:
        'Please fill out this information and our dealer will be in touch with you.',
      backCtaLabel: 'Back',
      submitLabel: 'Submit information to the dealer',
      legalDisclaimer:
        'By clicking "Submit information to the dealer", you agree to Volkswagen’s [Terms of Service](/en/terms.html) and [Privacy Statement](/en/privacy.html). In addition, by clicking "Submit information to the dealer", you also agree and consent to receive marketing communications regarding Volkswagen products and services from the Volkswagen authorized dealer you have selected, including by calling or texting you at the phone number(s) you’ve provided. If you have not selected a dealer, you agree and consent to receive marketing communications regarding Volkswagen products and services from the Volkswagen dealer associated with your zip code, including by calling or texting you at the phone number(s) you’ve provided. You understand these calls or text may be made using an automatic telephone dialing system and/or prerecorded message. Your consent to receive calls or texts is not required as a condition of any purchase or lease.',
      successMessage: {
        headerLabel: 'Thank you for contacting us!',
        description:
          '<p>We have received your message. <br /> <br /> Our team will contact you as soon as possible to give you the information you need.</p>',
        buttonCtaLabel: 'Okay',
      },
      failedMessage: {
        headerLabel: 'Oops! Something went wrong!',
        description:
          'We couldn’t receive your message at the moment. Please try again.',
        buttonCtaLabel: 'Back to $$formName$$',
      },
    },
    contactDealer: {
      formName: 'Contact Dealer',
      description:
        'Please fill out this information and our dealer will be in touch with you.',
      backCtaLabel: 'Back',
      submitLabel: 'Submit information to the dealer',
      legalDisclaimer:
        'By clicking "Submit information to the dealer", you agree to Volkswagen’s [Terms of Service](/en/terms.html) and [Privacy Statement](/en/privacy.html). In addition, by clicking "Submit information to the dealer", you also agree and consent to receive marketing communications regarding Volkswagen products and services from the Volkswagen authorized dealer you have selected, including by calling or texting you at the phone number(s) you’ve provided. If you have not selected a dealer, you agree and consent to receive marketing communications regarding Volkswagen products and services from the Volkswagen dealer associated with your zip code, including by calling or texting you at the phone number(s) you’ve provided. You understand these calls or text may be made using an automatic telephone dialing system and/or prerecorded message. Your consent to receive calls or texts is not required as a condition of any purchase or lease.',
      successMessage: {
        headerLabel: 'Thank you for contacting us!',
        description:
          '<p>We have received your message. <br /> <br /> Our team will contact you as soon as possible to give you the information you need.</p>',
        buttonCtaLabel: 'Okay',
      },
      failedMessage: {
        headerLabel: 'Oops! Something went wrong!',
        description:
          'We couldn’t receive your message at the moment. Please try again.',
        buttonCtaLabel: 'Back to $$formName$$',
      },
    },
  },
  resultsSection: {
    vehicleCard: {
      warranty: 'warranty',
      mileage: 'miles',
    },
    headerResults: {
      resultsMarkdownLabel:
        'Showing **%%current%%** of %%totalElements%% available vehicles within a **%%miles%% miles radius**',
      sortLabel: 'Sort by',
      sortShortLabel: 'Sort',
    },
    filters: {
      dealers: {
        label: 'All Dealerships',
        milesLabel: 'miles away',
        ctaLabel: 'Dealers',
      },
      distance: {
        label: 'Distance',
        milesLabel: 'miles',
      },
      price: {
        label: 'Price',
        ctaLabel: 'Price',
        ctaApplyLabel: 'Apply price',
        activeFilterLabels: {
          maxLabel: 'Max price',
          minLabel: 'Min price',
        },
      },
      models: {
        label: 'Model',
        ctaLabel: 'Model',
      },
      years: {
        label: 'Year',
        ctaLabel: 'Year',
      },
      mileage: {
        label: 'Mileage',
        activeFilterLabels: {
          maxLabel: 'Max mileage',
          minLabel: 'Min mileage',
        },
      },
      fuelType: {
        label: 'Fuel Type',
      },
      transmission: {
        label: 'Transmission',
      },
      interiorColor: {
        label: 'Interior Color',
      },
      exteriorColor: {
        label: 'Exterior Color',
      },
      buttonShowNumResultsLabel: 'Show %%NUM%% results',
    },
    noResults: {
      sorryTitle: "We're sorry!",
      noMatchTitle:
        "We can't seem to find any vehicles that match your search.",
      refineFilters: 'Please, refine your filters and search again.',
      moreInfoTitle:
        'Or contact your local dealership to get more information.',
      findMoreInfo:
        'Let us find more information for you from your dealership.',
    },
    appliedFilters: {
      label: 'Filtered by',
      ctaClearAllLabel: 'Reset All Filters',
    },
  },
  dealer: {
    distance: 'miles away',
  },
  detailsSection: {
    title: {
      miles: 'miles',
      vin: 'VIN',
      moneySign: '$',
    },
    gallery: {
      imagesCountLabel: '%%current%% of %%totalElements%%',
    },
    buyingProcessBox: {
      msrp: 'MSRP - Total vehicle price',
      lineWraper: 'Start your buying process',
      priceDetails: 'Dealer price details',
      makeAnOfferCTA: 'Make an offer',
      paymentCalcCTA: 'Estimate Payment',
    },
    estimatePaymentBox: {
      lineWraper: 'See your payment options',
      description: 'Estimate your monthly payment.',
      paymentCalcCTA: 'Estimate Payment',
    },
    DetailedSpecs: {
      mileageHeading: 'Mileage',
      transmissionHeading: 'Transmission',
      engineHeading: 'Engine',
      colorHeading: 'Color',
      descriptionHeading: 'Description',
      miles: 'miles',
    },
    carFaxBox: {
      title: '<b>SHOW</b> ME THE <b>CARFAX</b>',
      description:
        'CARFAX Vehicle History Reports are based only on information supplied to CARFAX. CARFAX does not have the complete history of every vehicle.',
      ctaText: 'Show me the CARFAX',
    },
    header: {
      buildMyDealLabel: 'Build my Deal',
      contactDealerButtonLabel: 'Contact a dealer',
      makeAnOfferButtonLabel: 'Make an offer',
      breadcrumbLabel: 'Back to results',
    },
    prequalify: {
      title: 'Pre-qualify now',
      description:
        'Learn if you pre-qualify for financing with Volkswagen Financial Services - with no impact to your credit score.',
      ctaLabel: 'Get pre-qualified',
    },
  },
  dealerDetails: {
    miles: 'miles away',
    contactADealerCTA: 'Contact dealer',
    visitDealerSiteLabel: "Visit dealer's site",
  },
  similarVehicles: {
    title: 'Similar Vehicles',
  },
};
